import React from "react";
import { IBitCompletedAction } from "../../../store/types";
import { FrameProps } from "../types";
import { IFrame } from "./animationTypes";
import useAnimation from "./useAnimation";
import { cleanName } from "../../bitTextParser";
import { buildFrames, getSpriteFrames } from "../../frameHelper";

const effectFramesMap: Record<IBitCompletedAction["key"], IFrame[]> = {
  attack: buildFrames(7, "blood_splatter2_"),

  // white magic
  heal: buildFrames(13, "consume1_"),
  protect: buildFrames(9, "circle_"),
  refresh: buildFrames(13, "consume2_"),
  shell: buildFrames(14, "bubble_"),

  // green magic
  poison: buildFrames(8, "poison_"),
  sleep: buildFrames(6, "sleep_"),
  blind: buildFrames(9, "dark_"),

  // black magic
  ice: buildFrames(8, "ice0_"),
  ice1: buildFrames(8, "ice1_"),
  ice2: buildFrames(8, "ice2_"),
  fire: buildFrames(8, "fire0_"),
  fire1: buildFrames(8, "fire1_"),
  fire2: buildFrames(8, "fire2_"),
  water: buildFrames(10, "water_"),
  earth: buildFrames(8, "earth0_"),
  earth1: buildFrames(8, "earth1_"),
  earth2: buildFrames(8, "earth1_"),
  wind: [...buildFrames(10, "spark1_"), ...buildFrames(7, "slash1_")],
  flame: buildFrames(5, "flame_")
};

function getEffectFrames(props: FrameProps["lastAction"]): IFrame[] {
  if (!props || !props.succeeded) return [];
  return effectFramesMap[props.key] || [];
}

function AnimatedSprite({ name, lastAction }: FrameProps) {
  const spriteFrames = getSpriteFrames(name);
  const effectFrames = getEffectFrames(lastAction);
  const { canvasRef, imageRef } = useAnimation(spriteFrames, effectFrames);
  return (
    <div className="sprite-container">
      <img
        ref={imageRef}
        className="sprite"
        alt="movement"
        src={`${process.env.PUBLIC_URL}/spritesheet.png`}
      />
      <canvas
        ref={canvasRef}
        id={name}
        width="32px"
        height="32px"
        className="sprite-canvas"
      />
      <span className="sprite-label">{cleanName(name)}</span>
    </div>
  );
}

export default React.memo(AnimatedSprite);
